import React from 'react';
import { ChefHat, Clock, AlertCircle, CheckCircle, TrendingUp } from 'lucide-react';
import { motion } from 'framer-motion';
import { useOrders } from '../contexts/OrderContext';
import { cleanProductName } from '../utils/formatters';
import { filterTodayOrders } from '../utils/dateFilters';
export function ProductionView() {
  const {
    orders
  } = useOrders();
  // Filter orders: only today's orders, exclude cancelled
  const todayOrders = filterTodayOrders(orders).filter(o => o.status !== 'Cancelado');
  // Calculate production stats from TODAY'S orders only
  const pendingOrders = todayOrders.filter(o => o.status === 'Pendiente' || o.status === 'En Preparación');
  const completedOrders = todayOrders.filter(o => o.status === 'Listo' || o.status === 'Entregado');
  const totalPending = pendingOrders.length;
  const totalCompleted = completedOrders.length;
  const totalOrders = todayOrders.length;
  // Group by product for production queue (clean product names)
  const productionQueue = pendingOrders.reduce((acc, order) => {
    const cleanName = cleanProductName(order.product);
    if (!acc[cleanName]) {
      acc[cleanName] = {
        name: cleanName,
        count: 0,
        priority: 'medium'
      };
    }
    acc[cleanName].count += order.quantity;
    return acc;
  }, {} as Record<string, {
    name: string;
    count: number;
    priority: string;
  }>);
  const queueItems = Object.values(productionQueue).sort((a, b) => b.count - a.count);
  return <div className="p-8 max-w-[1600px] mx-auto" data-id="element-2222">
      {/* Header Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-2223">
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200" data-id="element-2224">
          <div className="flex items-center justify-between mb-4" data-id="element-2225">
            <div className="p-3 bg-gray-100 rounded-xl" data-id="element-2226">
              <ChefHat className="w-6 h-6 text-gray-900" data-id="element-2227" />
            </div>
            <TrendingUp className="w-5 h-5 text-gray-400" data-id="element-2228" />
          </div>
          <p className="text-sm text-gray-500 font-medium mb-1" data-id="element-2229">Total Hoy</p>
          <p className="text-3xl font-bold text-gray-900" data-id="element-2230">{totalOrders}</p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200" data-id="element-2231">
          <div className="flex items-center justify-between mb-4" data-id="element-2232">
            <div className="p-3 bg-gray-100 rounded-xl" data-id="element-2233">
              <CheckCircle className="w-6 h-6 text-gray-900" data-id="element-2234" />
            </div>
            <span className="text-xs text-gray-500 font-medium" data-id="element-2235">
              {totalOrders > 0 ? Math.round(totalCompleted / totalOrders * 100) : 0}
              %
            </span>
          </div>
          <p className="text-sm text-gray-500 font-medium mb-1" data-id="element-2236">Completado</p>
          <p className="text-3xl font-bold text-gray-900" data-id="element-2237">{totalCompleted}</p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200" data-id="element-2238">
          <div className="flex items-center justify-between mb-4" data-id="element-2239">
            <div className="p-3 bg-gray-100 rounded-xl" data-id="element-2240">
              <AlertCircle className="w-6 h-6 text-gray-900" data-id="element-2241" />
            </div>
            <Clock className="w-5 h-5 text-gray-400" data-id="element-2242" />
          </div>
          <p className="text-sm text-gray-500 font-medium mb-1" data-id="element-2243">Pendiente</p>
          <p className="text-3xl font-bold text-gray-900" data-id="element-2244">{totalPending}</p>
        </div>
      </div>

      {/* Production Queue */}
      <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200" data-id="element-2245">
        <div className="flex items-center justify-between mb-6" data-id="element-2246">
          <div data-id="element-2247">
            <h2 className="text-xl font-bold text-gray-900" data-id="element-2248">
              Cola de Producción - Hoy
            </h2>
            <p className="text-sm text-gray-500 mt-1" data-id="element-2249">
              Platos pendientes de preparación para hoy
            </p>
          </div>
        </div>

        <div className="space-y-4" data-id="element-2250">
          {queueItems.length === 0 ? <div className="text-center py-12 text-gray-500" data-id="element-2251">
              No hay órdenes pendientes para hoy.
            </div> : queueItems.map((item, index) => <div key={item.name} className="p-5 rounded-xl border border-gray-200 hover:border-gray-400 transition-colors bg-gray-50" data-id="element-2252">
                <div className="flex items-center justify-between" data-id="element-2253">
                  <div data-id="element-2254">
                    <h3 className="text-lg font-bold text-gray-900" data-id="element-2255">
                      {item.name}
                    </h3>
                    <p className="text-sm text-gray-500" data-id="element-2256">Prioridad Normal</p>
                  </div>
                  <div className="text-right" data-id="element-2257">
                    <p className="text-xs text-gray-500 mb-1" data-id="element-2258">Cantidad</p>
                    <p className="text-2xl font-bold text-gray-900" data-id="element-2259">
                      {item.count}
                    </p>
                  </div>
                </div>
              </div>)}
        </div>
      </div>
    </div>;
}